export default __webpack_public_path__ + "static/data-more-about-img3--mobile-f0d8823821c728b19c0d537c0bccb70b.webp";